import React, { useCallback } from "react";
import PropTypes from "prop-types";
import { CTextInput } from "@appcues/component-library";

const ThemeInput = ({ label, draftTheme, setDraftTheme }) => {
  const handleChange = useCallback(
    value => {
      const labelName = label.name;
      setDraftTheme(prevDraftTheme => {
        return { ...prevDraftTheme, [labelName]: value };
      });
    },
    [setDraftTheme]
  );

  return (
    <CTextInput
      value={draftTheme[label.name]}
      onChange={handleChange}
      marginTop={16}
      maxWidth="95%"
    />
  );
};

ThemeInput.propTypes = {
  label: PropTypes.object.isRequired,
  draftTheme: PropTypes.object.isRequired,
  setDraftTheme: PropTypes.func.isRequired
};

export default ThemeInput;
